import styled from 'styled-components/native';

import { useTranslation } from '../../i18n';

interface Props {
  isOutOfStock: boolean;
  hasCVS: boolean;
  hasHomeCOD: boolean;
  hasCVSCOD: boolean;
}

export default function DeliveryTags(props: Props) {
  const { hasCVS, hasCVSCOD, hasHomeCOD, isOutOfStock } = props;
  const { t } = useTranslation();

  if (isOutOfStock || (hasCVS && hasHomeCOD && hasCVSCOD)) {
    return null;
  }

  return (
    <S.Container>
      <S.Text>{t('no-support')}</S.Text>
      <Tag visible={!hasCVS}>
        <S.Text>{t('hasCVS')}</S.Text>
      </Tag>
      <Tag visible={!hasHomeCOD || !hasCVSCOD}>
        <S.Text>{t('hasCOD')}</S.Text>
      </Tag>
    </S.Container>
  );
}

const Tag = ({ visible, children }) => {
  if (!visible) {
    return null;
  }

  return <S.Tag>{children}</S.Tag>;
};

const S = {
  Container: styled.View`
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  `,
  Tag: styled.View`
    flex-direction: row;
    align-items: center;
    padding: 1px 2px;
    border-color: ${({ theme }) => theme.palette.neutralDark}80;
    border-width: 1px;
    border-radius: 3px;
    margin: 0 0 0 5px;
  `,
  Text: styled.Text`
    font-size: 12px;
    color: ${({ theme }) => theme.palette.neutralDark};
    margin-left: 2px;
  `,
};
